/** =========================================================
 * Maintenances controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-maintenances')
    .controller('MaintenancesController', MaintenancesController);

  MaintenancesController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$translate'
  ];

  function MaintenancesController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $translate
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      vm.tableConfig = {
        model: 'maintenance',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: ['workgroup'],
          count: ['maintenance_events']
        },
        filters: angular.copy($stateParams.filters),
        resources: ['workgroup', 'user'],
        fields: [{
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Workgroup',
          key: 'workgroup_id',
          value: function (item) {
            return item.workgroup.name;
          },
          order: true
        }, {
          title: 'Periodicity (days)',
          key: 'first_date',
          customType: 'html',
          value: function (item) {
            return '<span><span>' + item.periodicity + ', <span><span class="text-muted">' + $translate.instant('Since') + ': ' + item.first_date + '<span></span>';
          },
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-maintenance.html',
          item: {
            user_id: $rootScope.appConfig.user.id
          }
        },
        edit: {
          template: 'app/views/dialogs/item-maintenance.html',
          except: [
            'workgroup',
            'maintenance_events_count'
          ]
        },
        delete: {},
        linkButtons: [{
          icon: 'icon-wrench',
          class: 'btn-info',
          title: 'Maintenance events',
          permission: $rootScope.helpers.hasPermissionTo('maintenance_event view'),
          action: function (item) {
            try {
              $state.go('app.page-maintenance-events', {
                filters: [{
                  name: $translate.instant('Maintenance') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['maintenance_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.maintenance_events_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }],
        topButtons: []
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
